export default function (handler) {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    handler()
  } else {
    document.addEventListener('DOMContentLoaded', handler, false)
  }
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/utilities/documentReady.js